import emailjs from '@emailjs/browser';

// EmailJS configuration
const SERVICE_ID = 'service_876ujcg';
const TEMPLATE_ID = 'template_vyptxkj';
const PUBLIC_KEY = 'pZNfIxEsL5NMAAnCv';

// Initialize EmailJS
emailjs.init(PUBLIC_KEY);

// Email routing based on form type
const getEmailDestination = (formType) => {
  const emailRoutes = {
    'Contact Form': 'support@vantagepointshospitality.net',
    'Guest Inquiry': 'guest@vantagepointshospitality.net',
    'Host Partnership': 'host@vantagepointshospitality.net',
    'Service Provider': 'service@vantagepointshospitality.net',
    'General Inquiry': 'support@vantagepointshospitality.net'
  };
  
  return emailRoutes[formType] || 'support@vantagepointshospitality.net';
};

// Send email function
export const sendEmail = async (formData, formType, pageName) => {
  try {
    const templateParams = {
      to_email: getEmailDestination(formType),
      from_name: formData.name || 'Guest User',
      from_email: formData.email,
      phone: formData.phone || 'Not provided',
      form_type: formType,
      subject: formData.subject || 'No subject',
      inquiry_type: formData.inquiryType || 'Not specified',
      preferred_contact: formData.preferredContact || 'Not specified',
      message: formData.message || 'No message provided',
      page_name: pageName,
      submission_date: new Date().toLocaleString()
    };

    const result = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', result);
    return { success: true, result };
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false, error };
  }
};